import axios from 'axios'
const baseurl = process.env.REACT_APP_API_URL

export const addProductToCart = async (id, quantity, token) => {
  const res = await axios({
    method: 'post',
    url: baseurl + `/addToCart`,
    data: {
      productId: id,
      quantity: quantity
    },
    headers: {
      token: token
    }
  })
}

export const getProductsInCart = async token => {
  try {
    const res = await axios({
      method: 'get',
      url: baseurl + `/getCart`,
      headers: {
        token: token
      }
    })
    return res.data.data
  } catch (error) {
    console.log(error)
  }
}
